export const MainBuildingEnvelopeRenewals = {
    "imageUrl": "/assets/imgs/services/1BuildingEnvelopeRenewals/fondo.png",
    "eyebrow": "Building Envelope",
    "title": "Renewals",
    "headingSpan": "PROTECT & EXTEND",
    "heading": "THE LIFE OF YOUR BUILDING",
    "description": "We restore and protect your building’s exterior with expert concrete repairs, painting, waterproofing, sealants, high-build coatings, flashings, and insulation—ensuring long-lasting durability, energy efficiency, and weather resistance for years to come.",
    "highlightSpan": "The best Building Envelope Renewal",
    "highlight": " / High-Rise Painting & Restoration services.",
    "button": {
        "text": "Request a Quote",
        "url": "/quote"
    }
};